import { render } from "./AskForQuoteAddress.vue?vue&type=template&id=5b6e291f"
import script from "./AskForQuoteAddress.vue?vue&type=script&lang=js"
export * from "./AskForQuoteAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__